import {Svg} from 'assets'

export const AllStatusesEnum = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    PENDING: "PENDING",
};

export const allStatuses = {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    PENDING: "Pending",
};

export const allStatusesList = [
    {
        id: AllStatusesEnum.ACTIVE,
        name: allStatuses.ACTIVE,
        style: {color: '#059669'},
        Icon: Svg.ActiveSvg
    },

    {
        id: AllStatusesEnum.INACTIVE,
        name: allStatuses.INACTIVE,
        style: {color: '#374151'},
        Icon: Svg.InactiveSvg
    },

    // {
    //     id: AllStatusesEnum.PENDING,
    //     name: allStatuses.PENDING,
    //     style: {color: '#D97706'},
    //     Icon: Svg.PendingSvg
    // },
];
